import styled from 'styled-components';

import {
  black,
  blue,
  border1,
  exactWhite,
  lightGrayBackground,
  red,
} from 'utils/style/colors';

import Input from 'components/Input';
import Icon from 'components/Icon';
import { languageDirection } from '../../i18n';

interface IQuestionWrapperProps {
  isUniqueQuestion?: boolean;
  disabled?: boolean;
}

export const Error = styled('div')`
  color: red;
`;

export const QuestionWrapper = styled('div')<IQuestionWrapperProps>`
  margin: 0.5rem 0 1rem 0;
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05); */
  border-radius: 10px;
  background-color: var(--exact-white);
  overflow: visible;
  display: ${(props) => props.isUniqueQuestion && 'none'};
  ${({ disabled }) =>
    disabled === true &&
    `
      opacity: 0.4;
      pointer-events: none;
  `}
`;

export const QuestionBody = styled('div')`
  padding: 0.25rem 1.25rem;
  display: block;
  color: ${black};
`;

export const FixedKeyVal = styled.p`
  & > span {
    font-weight: 500;
  }
`;

export const SubAnswer = styled('div')`
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  padding: 0.5rem 0.5rem 0.5rem 0.5rem;
  border: ${border1};
  background: ${lightGrayBackground};
  border-radius: 10px;
`;

export const DeleteIcon = styled(Icon)`
  position: absolute;
  border-radius: 10px;
  background-color: ${red};
  color: ${exactWhite};
  display: block;
  top: 1px;
  cursor: pointer;
  ${(_) =>
    languageDirection() === 'rtl'
      ? 'left: 1px !important;'
      : 'right: 1px !important;'}
`;

export const SubAnswerWrapper = styled('div')`
  padding: 0.5rem 0.5rem 0.5rem 0.5rem !important;
  position: relative;
`;

export const IndicatorInput = styled(Input)`
  direction: ${(_) => languageDirection()};
  text-align: center;
`;

export const RemoveSelectedIcon = styled(Icon)`
  color: ${red};
  cursor: pointer;
  display: inline-block;
  transition: all 0.3s ease;
  margin-left: 1rem;
  :hover {
    opacity: 0.7;
  }
`;

export const AddAnswerButton = styled('div')`
  padding: 0.5rem 0.5rem 0.5rem 0.5rem !important;
  display: flex;
  cursor: pointer;
  & > div {
    padding: 10px;
    width: 100%;
    border-style: dashed;
    border-color: ${blue};
    border-width: 2px;
    border-radius: 10px;
  }
`;

export const QuestionChoiceContainer = styled.div`
  display: grid;
  ${(props) =>
    props.isInline
      ? `
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
  `
      : `
    grid-template-columns: repeat(${props.colNumber}, 1fr);
  grid-template-rows: repeat(auto-fit, minmax(20px, 1fr));
  grid-gap: 0.25rem;
  `}
`;

export const HintWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border-radius: 0.5rem;
  padding: 0.5rem 0.75rem;
`;

export const HintInfoWrapper = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const HintTitle = styled.div`
  font-weight: bold;
`;

export const HintInfoContent = styled.div``;
